import "bootstrap/dist/css/bootstrap.css";
import React from 'react';
import ReactDOM from 'react-dom';
// import ReactDOM from 'react/client';
import App from './App';
import * as serviceWorker from "./serviceWorker";
import {Auth0Provider} from "./react-auth0-spa";
import config from "./auth_config.json";
import history from "./history";
import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';

const onRedirectCallback = appState => {
    history.push(
        appState && appState.targetUrl ? appState.targetUrl : window.location.pathname
    );
};



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain={config.domain}
    client_id={config.clientId}
    redirect_uri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
  >
      <StrictMode>
          <BrowserRouter>
              <App />
          </BrowserRouter>
      </StrictMode>
  </Auth0Provider>
);

